export default ['de', 'it', 'sv', 'pl', 'hu', 'nl', 'hr'];
